__turbopack_context__.v({
  "article-wrapper": "AHmzUG_article-wrapper",
  "desc": "AHmzUG_desc",
  "section": "AHmzUG_section",
  "title": "AHmzUG_title",
  "viewMore": "AHmzUG_viewMore",
});
